import { Link } from 'react-router-dom';
import TextField from '../../../components/Input/text-field';
import './edit-role.scss';
import ResourcePermissions from './resource-permissions';

const EditRoleForm = ({ name,
    setName,    
    onSaveRole,    
    controllers,
    checkedResources,
    onChangeResourcesList,
    onAddResourcesList,
    onRemoveResourcesList,
    readOnly,
    projects,
    selectedProjects,
    onAddProject,
    onRemoveProject,
    setPermission,
    showSpecificProjects
     }: any) => {
    

    return (
    <div>              
        <TextField
            type="text" 
            label="Name" 
            className="role-name"
            value={name} 
            onChange={setName}
            readOnly={readOnly} />   

        <ResourcePermissions 
            readOnly={readOnly} 
            projects={projects} 
            selectedProjects={selectedProjects} 
            showSpecificProjects={showSpecificProjects} 
            controllers={controllers} 
            checkedResources={checkedResources} 
            onChangeResourcesList={onChangeResourcesList} 
            onAddResourcesList={onAddResourcesList} 
            onRemoveResourcesList={onRemoveResourcesList}
            onAddProject={onAddProject}
            onRemoveProject={onRemoveProject}
            setPermission={setPermission}
             />
        <div className="field is-grouped mt-4 mb-4">
            <div className="control">
                <Link className='button' to={`/admin/role/list`}>Cancel</Link>
            </div>
            {!readOnly && 
                <div className="control">
                    <button className="button is-primary" type="submit" onClick={onSaveRole}>Save Role</button>
                </div>        
            }        
        </div>               
    </div>
    )    
};

export default EditRoleForm;